export const siteComponentsExternals = [
  /^react$/,
  /^react\/jsx-runtime$/,
  /^react\/jsx-dev-runtime$/,
  /^react-dom$/,
  /^@wix\/services-manager-react$/,
  // Temporary hardcoded externals for ref elements:
  /^@wix\/editor-react-components($|\/)/,
];
